import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';
import getLocale from '../../../i18n/getLocale';


class FlightReportRefuelEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      id: this.props.flight_report_refuel_edit.id,
      approval_required: 0,
      export_required: 0,
      aircraft_id: this.props.flight_report_refuel_edit.aircraft_id,
      date: this.props.flight_report_refuel_edit.date,
      flight_report_id: this.props.flight_report_refuel_edit.flight_report_id,
      flight_report_leg_id: this.props.flight_report_refuel_edit.flight_report_leg_id,
      fuel_supplier_id: this.props.flight_report_refuel_edit.fuel_supplier_id,
      location_id: this.props.flight_report_refuel_edit.location_id,
      quantity: this.props.flight_report_refuel_edit.quantity,
      receit: this.props.flight_report_refuel_edit.receit,
      requested: this.props.flight_report_refuel_edit.requested,
      address: this.props.flight_report_refuel_edit.address,
      staff_id: this.props.flight_report_refuel_edit.staff_id,
      fueling_started: this.props.flight_report_refuel_edit.fueling_started,
      fueling_finished: this.props.flight_report_refuel_edit.fueling_finished,
      next_location_id: this.props.flight_report_refuel_edit.next_location_id,
      hydrant_no: this.props.flight_report_refuel_edit.hydrant_no,
      your_sale_no: this.props.flight_report_refuel_edit.your_sale_no,
      previous_sale_no: this.props.flight_report_refuel_edit.previous_sale_no,
      reading_finish: this.props.flight_report_refuel_edit.reading_finish,
      reading_start: this.props.flight_report_refuel_edit.reading_start,
      fuel_type: this.props.flight_report_refuel_edit.fuel_type,
      fuel_type_id: this.props.flight_report_refuel_edit.fuel_type_id,
      unitary_value: this.props.flight_report_refuel_edit.unitary_value,
      total_value: this.props.flight_report_refuel_edit.total_value,
      refundable_value: this.props.flight_report_refuel_edit.refundable_value,
      final_value: this.props.flight_report_refuel_edit.final_value,      
      fuel_suppliers_select: this.props.fuel_suppliers_select,
      aircrafts_select: this.props.aircrafts_select,
      locations_select: this.props.locations_select,
      fuel_types_select: this.props.fuel_types_select,
      companies_select: this.props.companies_select,
      staff_select: this.props.staff_select,
      flight_report_legs: [],
    };

    this.edit = this.edit.bind(this);
    this.export_receipt = this.export_receipt.bind(this);
    this.locale = getLocale();
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeDate (name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      change[name] = date;
    }
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleChangeGallonsReading (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    
    if (name == 'reading_start') {
      var start = event.target.value;
    } else {
      var start = this.state.reading_start;
    }
    if (name == 'reading_finish') {
      var finish = event.target.value;
    } else {
      var finish = this.state.reading_finish;
    }
    var delivered = (parseInt(finish) - parseInt(start));
    this.setState({quantity: delivered});
  }
  handleExtraFlightToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChangeFuelType(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      var header = this.refs.request_api.header('application/json');
      var self = this;
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/tipo/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            fuel_type: responseJson.data.abbreviation,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeLeg(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            locations_select: responseJson.data.locations_select,
            location_id: responseJson.data.flight_report_leg.departure_location_id,
            next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
            reading_start: responseJson.data.flight_report_leg.fuel_start
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeFuelSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/fornecedor/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            approval_required: responseJson.data.main.refuel_approval_required,
            export_required: responseJson.data.main.refuel_export_required,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChangeCompany(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empresa/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province,
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.id === 'undefined' || this.state.loaded !== 1) {
        this.setState({
            id: newProps.flight_report_refuel_edit.id,
            aircraft_id: newProps.flight_report_refuel_edit.aircraft_id,
            file_export: newProps.flight_report_refuel_edit.file,
            date: newProps.flight_report_refuel_edit.date,
            flight_report_id: newProps.flight_report_refuel_edit.flight_report_id,
            flight_report_leg_id: newProps.flight_report_refuel_edit.flight_report_leg_id,
            fuel_supplier_id: newProps.flight_report_refuel_edit.fuel_supplier_id,
            location_id: newProps.flight_report_refuel_edit.location_id,
            quantity: newProps.flight_report_refuel_edit.quantity,
            receit: newProps.flight_report_refuel_edit.receit,
            requested: newProps.flight_report_refuel_edit.requested,
            address: newProps.flight_report_refuel_edit.address,
            staff_id: newProps.flight_report_refuel_edit.staff_id,
            fueling_started: newProps.flight_report_refuel_edit.fueling_started,
            fueling_finished: newProps.flight_report_refuel_edit.fueling_finished,
            next_location_id: newProps.flight_report_refuel_edit.next_location_id,
            hydrant_no: newProps.flight_report_refuel_edit.hydrant_no,
            your_sale_no: newProps.flight_report_refuel_edit.your_sale_no,
            previous_sale_no: newProps.flight_report_refuel_edit.previous_sale_no,
            reading_finish: newProps.flight_report_refuel_edit.reading_finish,
            reading_start: newProps.flight_report_refuel_edit.reading_start,
            fuel_type: newProps.flight_report_refuel_edit.fuel_type,
            fuel_type_id: newProps.flight_report_refuel_edit.fuel_type_id,
            unitary_value: newProps.flight_report_refuel_edit.unitary_value,
            total_value: newProps.flight_report_refuel_edit.total_value,
            refundable_value: newProps.flight_report_refuel_edit.refundable_value,
            final_value: newProps.flight_report_refuel_edit.final_value,
            flight_report_legs: newProps.flight_report_legs_select,
            fuel_suppliers_select: newProps.fuel_suppliers_select,
            aircrafts_select: newProps.aircrafts_select,
            locations_select: newProps.locations_select,
            fuel_types_select: newProps.fuel_types_select,
            companies_select: newProps.companies_select,
            staff_select: newProps.staff_select,
            loaded: 1,
        });
      }

      if (typeof newProps.flight_report_refuel_edit.fuel_supplier_id !== 'undefined' && this.state.loaded === 1 && this.state.load_fuel_supplier !== 1) {
        //Atualiza os dados do fornecedor de combustível
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var fuel_supplier_id = newProps.flight_report_refuel_edit.fuel_supplier_id;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/fornecedor/combustivel/'+ fuel_supplier_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              approval_required: responseJson.data.main.refuel_approval_required,
              export_required: responseJson.data.main.refuel_export_required,
              load_fuel_supplier: 1,
            });
          });
        });
      }

      if (typeof newProps.flight_report_refuel_edit.flight_report_id !== 'undefined' && this.state.loaded === 1) {
        // Atualiza os dados do relatório
        var change = {};
        var self = this;
        var flight_report_id = newProps.flight_report_refuel_edit.flight_report_id;
        if(self.state.flight_report_legs[flight_report_id]) {
            change['flight_report_legs_select'] = self.state.flight_report_legs[flight_report_id];
        } else {
            change['flight_report_legs_select'] = [];
        }
        self.setState(change);
      }

      if (typeof newProps.flight_report_refuel_edit.flight_report_leg_id !== 'undefined' && this.state.loaded === 1 && this.state.load_flight_report_leg !== 1) {
        // Atualiza os dados do trecho
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var flight_report_leg_id = newProps.flight_report_refuel_edit.flight_report_leg_id;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+ flight_report_leg_id, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              locations_select: responseJson.data.locations_select,
              load_flight_report_leg: 1,
            });
          });
        });
      }
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    var datasave = new FormData();
    var imagedata = document.querySelector(".input-nf-file").files[0];
    datasave.append("id", this.state.id);
    datasave.append("aircraft_id", this.state.aircraft_id);
    datasave.append("date", this.state.date);
    datasave.append("flight_report_id", this.state.flight_report_id);
    datasave.append("flight_report_leg_id", this.state.flight_report_leg_id);
    datasave.append("fuel_supplier_id", this.state.fuel_supplier_id);
    datasave.append("location_id", this.state.location_id);
    datasave.append("quantity", this.state.quantity);
    datasave.append("file", imagedata);
    datasave.append("receit", this.state.receit);
    datasave.append("requested", this.state.requested);
    datasave.append("address", this.state.address);
    datasave.append("staff_id", this.state.staff_id);
    datasave.append("fueling_started", this.state.fueling_started);
    datasave.append("fueling_finished", this.state.fueling_finished);
    datasave.append("next_location_id", this.state.next_location_id);
    datasave.append("hydrant_no", this.state.hydrant_no);
    datasave.append("your_sale_no", this.state.your_sale_no);
    datasave.append("previous_sale_no", this.state.previous_sale_no);
    datasave.append("reading_finish", this.state.reading_finish);
    datasave.append("reading_start", this.state.reading_start);
    datasave.append("fuel_type", this.state.fuel_type);
    datasave.append("fuel_type_id", this.state.fuel_type_id);
    var header = this.refs.request_api.header();
    var self = this;
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio/voo/abastecimento/editar', { method: 'POST', mode: 'cors', headers: value, body: datasave }).then((response) => response.json()).catch((error) => { console.error(error); self.props.handleAlert(error.message, error.status, 'open');}).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  formFields(fields_type) {

    var fields = '';

    if (fields_type == 0) {
      fields = (
        <div className="row">
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelSolicitado}:</label>
              <InputMask value={this.state.requested}  maskChar={null} name="requested " mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroDaCe}:</label>
              <input type="text" name="receit" className="form-control" placeholder="" value={this.state.receit} onChange={this.handleChange.bind(this, 'receit')} required />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelAbastecido}:</label>
              <InputMask value={this.state.quantity}  maskChar={null} name="quantity " mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="" required/>
          </div>
        </div>
      );
    } else {
      fields = (
        <div>
          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Endereco}</label>
                <input type="text" name="address" className="form-control" placeholder="" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Comandante}</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staff_select}
                />
            </div>
            <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.InicioAbastecimento}:</label>
                <InputMask value={this.state.fueling_started}  maskChar={null} name="fueling_started " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_started')} placeholder="hh:mm" />
            </div>
            <div className="col-md-1 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_started')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
            <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TerminoAbastecimento}:</label>
                <InputMask value={this.state.fueling_finished}  maskChar={null} name="fueling_finished " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_finished')} placeholder="hh:mm" />
            </div>
            <div className="col-md-1 form-group">
              <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_finished')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ProximaLocalidade}:</label>
                <Select
                  className="form-field-name"
                  name="next_location_id"
                  value={this.state.next_location_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'next_location_id')}
                  options={this.state.locations_select}
                  required
                />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroHidrante}:</label>
                <input type="number" name="hydrant_no" className="form-control" placeholder="999" value={this.state.hydrant_no} onChange={this.handleChange.bind(this, 'hydrant_no')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.SeuNumeroDeVenda}:</label>
                <input type="text" name="your_sale_no" className="form-control" placeholder="" value={this.state.your_sale_no} onChange={this.handleChange.bind(this, 'your_sale_no')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroDeVendaAnterior}:</label>
                <input type="text" name="previous_sale_no" className="form-control" placeholder="" value={this.state.previous_sale_no} onChange={this.handleChange.bind(this, 'previous_sale_no')} required />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraFinal}:</label>
                <input type="number" name="reading_finish" className="form-control" placeholder="999" value={this.state.reading_finish} onChange={this.handleChangeGallonsReading.bind(this, 'reading_finish')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraInicial}:</label>
                <input type="number" name="reading_start" className="form-control" placeholder="999" value={this.state.reading_start} onChange={this.handleChangeGallonsReading.bind(this, 'reading_start')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Entregues}:</label>
                <InputMask value={this.state.quantity}  maskChar={null} name="quantity" mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="9999" required/>
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TipoCombustivel}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_type_id"
                  value={this.state.fuel_type_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeFuelType.bind(this, 'fuel_type_id')}
                  options={this.state.fuel_types_select}
                  required
                />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorUnitario}:</label>
                <input type="number" value={this.state.unitary_value} name="unitary_value" className="form-control" onChange={this.handleChange.bind(this, 'unitary_value')} placeholder="999,99" readOnly />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorTotal}:</label>
                <input type="number" value={this.state.total_value} name="total_value" className="form-control" onChange={this.handleChange.bind(this, 'total_value')} placeholder="999,99" readOnly />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorReembolsavel}:</label>
                <input type="number" value={this.state.refundable_value} name="refundable_value" className="form-control" onChange={this.handleChange.bind(this, 'refundable_value')} placeholder="999,99" readOnly />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorFinal}:</label>
                <input type="number" value={this.state.final_value} name="final_value" className="form-control" onChange={this.handleChange.bind(this, 'final_value')} placeholder="999,99" readOnly />
            </div>
          </div>

        </div>
      );
    }

    return fields;

  }

  export_receipt() {
    var url = '/files/refuels/' + this.state.id + '_' + this.state.file_export;
    window.open(config.get('cdn') + url);
  }


  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.EditarAbastecimento.dados}</h3>
  <button className="btn btn-success btn-sm pull-right" onClick={() => this.export_receipt()}><i className="fa fa-fw fa-download"></i></button>
  <div className="clearfix"></div>
  <hr/>
  <form onSubmit={this.edit}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Fornecedor}:</label>
        <Select
          className="form-field-name"
          name="fuel_supplier_id"
          value={this.state.fuel_supplier_id}
          searchable={true}
          placeholder={'Selecione'}
          onChange={this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id')}
          options={this.state.fuel_suppliers_select}
          required
        />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.AnexarNotaFiscal}:</label>
        <input type="file" name="file" className="form-control input-nf-file" value={this.state.file} onChange={this.handleChange.bind(this, 'file')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-4 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Relatorio}:</label>
          <input className="form-control" name="flight_report_id" value={this.state.flight_report_id} onChange={this.handleChange.bind(this, 'flight_report_id')} readOnly required />
      </div>
      <div className="col-md-4 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Trecho}:</label>
          <Select
              className="form-field-name"
              name="flight_report_leg_id"
              value={this.state.flight_report_leg_id}
              searchable={true}
              placeholder={'Selecione'}
              onChange={this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id')}
              options={this.state.flight_report_legs_select}
              required
          />
      </div>
      <div className="col-md-4 form-group">
          <label>{this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Localidade}:</label>
          <Select
            className="form-field-name"
            name="location_id"
            value={this.state.location_id}
            searchable={true}
            placeholder={'Selecione'}
            onChange={this.handleSelectChange.bind(this, 'location_id')}
            options={this.state.locations_select}
            required
          />
      </div>
    </div>
    {this.formFields(this.state.export_required)}
    <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.botaoEditarAbastecimento}</button>
  </form>
</div>
    );
  }
}

export default FlightReportRefuelEditTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/Elements/FlightReportRefuelEditTab.js